import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { PartnerEmail } from '@/types/partner';

interface InviteStillValidModalProps {
  isOpen: boolean;
  client: PartnerEmail | null;
  onClose: () => void;
}

export function InviteStillValidModal({ isOpen, client, onClose }: InviteStillValidModalProps) {
  if (!client) return null;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[480px] w-[calc(100%-2rem)] rounded-2xl gap-6">
        <DialogHeader className="space-y-4">
          <DialogTitle className="text-xl font-bold text-gray-900">
            Tudo certo por aqui
          </DialogTitle>
          <DialogDescription className="text-sm text-gray-900 font-normal leading-relaxed">
            O convite para <strong className="font-semibold">{client.email}</strong> foi enviado e
            ainda está dentro do prazo. Assim que ele aceitar, o status atualiza automaticamente
            para Ativo.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex justify-end sm:justify-end">
          <Button type="button" variant="outline" onClick={onClose} className="min-w-[100px]">
            Fechar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
